var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contact-list" },
    [
      _c(
        "div",
        { staticClass: "contact-list-content" },
        [
          _c("NewSupsisTable", {
            attrs: {
              columns: _vm.tableColumns,
              data: _vm.processedContacts,
              loading: _vm.loading,
              zebra: false,
              "sortable-columns": true,
              "local-storage-key": _vm.tableLocalStorageKey,
              "min-column-width": 80,
              groups: _vm.groups,
              "scroll-loading": _vm.scrollLoading,
              "external-scroll-top": _vm.scrollTop,
              "external-container-height": _vm.containerHeight,
              selectable: _vm.selectable,
              "max-select-count": _vm.maxSelectCount,
              filterable: _vm.filterable,
              filters: _vm.filters,
              "sort-field": _vm.sortField,
              "sort-direction": _vm.sortDirection,
            },
            on: {
              "row-click": _vm.onRowClick,
              "row-dblclick": _vm.onRowDblClick,
              "scroll-load": _vm.onScrollLoad,
              "selection-change": _vm.onSelectionChange,
              "filter-toggle": _vm.onFilterToggle,
              "sort-change": _vm.onSortChange,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "cell-avatar",
                  fn: function (slotProps) {
                    return [
                      _c("ContactAvatar", {
                        attrs: { contact: slotProps.row, size: "smallest" },
                      }),
                    ]
                  },
                },
                {
                  key: "cell-name",
                  fn: function (slotProps) {
                    return [
                      _c("div", { staticClass: "contact-name" }, [
                        _c("span", { staticClass: "name-text" }, [
                          _vm._v(
                            _vm._s(
                              (slotProps.row && slotProps.row.fullname) || "-"
                            )
                          ),
                        ]),
                      ]),
                    ]
                  },
                },
                {
                  key: "cell-platform",
                  fn: function (slotProps) {
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "platform-badge",
                          class:
                            "platform-" +
                            (slotProps.row && slotProps.row.platform),
                        },
                        [
                          (slotProps.row && slotProps.row.platform) === "supsis"
                            ? _c("SupsisIcon", {
                                staticClass: "platform-icon supsis-icon",
                              })
                            : _c(
                                "i",
                                { staticClass: "material-icons platform-icon" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.getPlatformIcon(
                                        slotProps.row && slotProps.row.platform
                                      )
                                    )
                                  ),
                                ]
                              ),
                          _vm._v(" "),
                          _c("span", { staticClass: "platform-text" }, [
                            _vm._v(
                              _vm._s(slotProps.row && slotProps.row.platform)
                            ),
                          ]),
                        ],
                        1
                      ),
                    ]
                  },
                },
                {
                  key: "cell-email",
                  fn: function (slotProps) {
                    return [
                      _c("span", { staticClass: "email-text" }, [
                        _vm._v(
                          _vm._s((slotProps.row && slotProps.row.email) || "-")
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: "cell-phone",
                  fn: function (slotProps) {
                    return [
                      _c("span", { staticClass: "phone-text" }, [
                        _vm._v(
                          _vm._s((slotProps.row && slotProps.row.phone) || "-")
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: "cell-tags",
                  fn: function (slotProps) {
                    return [
                      _c(
                        "div",
                        { staticClass: "tags-container" },
                        [
                          _vm._l(
                            _vm.getContactTags(slotProps.row),
                            function (tag) {
                              return _c(
                                "span",
                                {
                                  key: tag._id,
                                  staticClass: "tag-chip",
                                  style: _vm.getTagStyle(tag),
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(tag.name) +
                                      "\n                        "
                                  ),
                                ]
                              )
                            }
                          ),
                          _vm._v(" "),
                          !_vm.getContactTags(slotProps.row).length
                            ? _c("span", { staticClass: "no-tags" }, [
                                _vm._v("-"),
                              ])
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]
                  },
                },
                {
                  key: "cell-channel",
                  fn: function (slotProps) {
                    return [
                      _c("span", { staticClass: "channel-text" }, [
                        _vm._v(_vm._s(_vm.getChannelName(slotProps.row))),
                      ]),
                    ]
                  },
                },
                {
                  key: "cell-status",
                  fn: function (slotProps) {
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "status-badge",
                          class: _vm.getStatusClass(
                            slotProps.row &&
                              slotProps.row.lastConversation &&
                              slotProps.row.lastConversation.status
                          ),
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.getStatusText(
                                  slotProps.row &&
                                    slotProps.row.lastConversation &&
                                    slotProps.row.lastConversation.status
                                )
                              ) +
                              "\n                    "
                          ),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "cell-owner",
                  fn: function (slotProps) {
                    return [
                      _c("span", { staticClass: "owner-text" }, [
                        _vm._v(_vm._s(_vm.getOwnerName(slotProps.row))),
                      ]),
                    ]
                  },
                },
                {
                  key: "cell-vip",
                  fn: function (slotProps) {
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "vip-indicator",
                          class: {
                            "vip-active":
                              slotProps.row && slotProps.row.vipCustomer,
                          },
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v(
                              _vm._s(
                                slotProps.row && slotProps.row.vipCustomer
                                  ? "star"
                                  : "star_border"
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "cell-connectionTime",
                  fn: function (slotProps) {
                    return [
                      _c(
                        "a-tooltip",
                        {
                          attrs: {
                            title: _vm.formatFullDateTime(
                              slotProps.row.connectionTime
                            ),
                          },
                        },
                        [
                          _c("span", { staticClass: "connection-time" }, [
                            _vm._v(
                              _vm._s(_vm.formatConnectionTime(slotProps.row))
                            ),
                          ]),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "cell-lastActionTime",
                  fn: function (slotProps) {
                    return [
                      _c(
                        "a-tooltip",
                        {
                          attrs: {
                            title: _vm.formatFullDateTime(
                              slotProps.row.lastActionTime
                            ),
                          },
                        },
                        [
                          _c("span", { staticClass: "last-action-time" }, [
                            _vm._v(
                              _vm._s(_vm.formatLastActionTime(slotProps.row))
                            ),
                          ]),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "cell-answerStatus",
                  fn: function (slotProps) {
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "answer-status",
                          class:
                            "answer-" +
                            (slotProps.row && slotProps.row.answerStatus),
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.getAnswerStatusText(
                                  slotProps.row && slotProps.row.answerStatus
                                )
                              ) +
                              "\n                    "
                          ),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "cell-unread",
                  fn: function (slotProps) {
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "unread-status",
                          class: {
                            "unread-active":
                              slotProps.row && slotProps.row.unread,
                          },
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v(
                              _vm._s(
                                slotProps.row && slotProps.row.unread
                                  ? "mark_email_unread"
                                  : "mark_email_read"
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "cell-relatedDepartments",
                  fn: function (slotProps) {
                    return [
                      _c("div", { staticClass: "departments-container" }, [
                        _c("span", { staticClass: "departments-text" }, [
                          _vm._v(
                            _vm._s(_vm.getRelatedDepartments(slotProps.row))
                          ),
                        ]),
                      ]),
                    ]
                  },
                },
                {
                  key: "cell-os",
                  fn: function (slotProps) {
                    return [
                      _c("span", { staticClass: "os-text" }, [
                        _vm._v(
                          _vm._s((slotProps.row && slotProps.row.os) || "-")
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: "cell-browser",
                  fn: function (slotProps) {
                    return [
                      _c("span", { staticClass: "browser-text" }, [
                        _vm._v(
                          _vm._s(
                            (slotProps.row && slotProps.row.browser) || "-"
                          )
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: "cell-countryCity",
                  fn: function (slotProps) {
                    return [
                      _c("span", { staticClass: "country-city-text" }, [
                        _vm._v(_vm._s(_vm.getCountryCity(slotProps.row))),
                      ]),
                    ]
                  },
                },
                {
                  key: "cell-ipAddress",
                  fn: function (slotProps) {
                    return [
                      _c("span", { staticClass: "ip-address-text" }, [
                        _vm._v(
                          _vm._s(
                            (slotProps.row && slotProps.row.ipAddress) || "-"
                          )
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: "cell-visitingPage",
                  fn: function (slotProps) {
                    return [
                      _c(
                        "span",
                        {
                          staticClass: "visiting-page-text",
                          attrs: {
                            title:
                              (slotProps.row && slotProps.row.visitingPage) ||
                              "-",
                          },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                (slotProps.row && slotProps.row.visitingPage) ||
                                  "-"
                              ) +
                              "\n                    "
                          ),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "cell-lastConversationCreatedDate",
                  fn: function (slotProps) {
                    return [
                      _c(
                        "a-tooltip",
                        {
                          attrs: {
                            title: _vm.formatFullDateTime(
                              slotProps.row.lastConversation &&
                                slotProps.row.lastConversation.createdDate
                            ),
                          },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "last-conversation-date" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.getLastConversationDate(slotProps.row)
                                )
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "cell-createdAt",
                  fn: function (slotProps) {
                    return [
                      _c(
                        "a-tooltip",
                        {
                          attrs: {
                            title: _vm.formatFullDateTime(
                              slotProps.row.createdAt
                            ),
                          },
                        },
                        [
                          _c("span", { staticClass: "created-at-text" }, [
                            _vm._v(_vm._s(_vm.formatCreatedAt(slotProps.row))),
                          ]),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "cell-updatedAt",
                  fn: function (slotProps) {
                    return [
                      _c(
                        "a-tooltip",
                        {
                          attrs: {
                            title: _vm.formatFullDateTime(
                              slotProps.row.updatedAt
                            ),
                          },
                        },
                        [
                          _c("span", { staticClass: "updated-at-text" }, [
                            _vm._v(_vm._s(_vm.formatUpdatedAt(slotProps.row))),
                          ]),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "cell-blockedSnapshot",
                  fn: function (slotProps) {
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "blocked-status",
                          class: {
                            "blocked-active":
                              slotProps.row && slotProps.row.blockedSnapshot,
                          },
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v(
                              _vm._s(
                                slotProps.row && slotProps.row.blockedSnapshot
                                  ? "block"
                                  : "check_circle"
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.getBlockedStatus(slotProps.row))),
                          ]),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "cell-lastConversationUsers",
                  fn: function (slotProps) {
                    return [
                      _c(
                        "div",
                        { staticClass: "conversation-users-container" },
                        [
                          _vm._l(
                            _vm.getConversationUserIds(slotProps.row),
                            function (userId) {
                              return _c(
                                "div",
                                { key: userId, staticClass: "user-item" },
                                [
                                  _c("AgentAvatar", {
                                    staticClass: "user-mini-avatar",
                                    attrs: {
                                      userID: userId,
                                      size: 24,
                                      fontSize: 10,
                                      isNamed: false,
                                      singleChar: true,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "user-name" }, [
                                    _vm._v(_vm._s(_vm.getUserName(userId))),
                                  ]),
                                ],
                                1
                              )
                            }
                          ),
                          _vm._v(" "),
                          !_vm.getConversationUserIds(slotProps.row).length
                            ? _c("span", { staticClass: "no-users" }, [
                                _vm._v("-"),
                              ])
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]
                  },
                },
                {
                  key: "cell-preferredLang",
                  fn: function (slotProps) {
                    return [
                      _c("span", { staticClass: "preferred-lang-text" }, [
                        _vm._v(
                          _vm._s(_vm.getPreferredLangLabel(slotProps.row))
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: "cell-zohoContactId",
                  fn: function (slotProps) {
                    return [
                      _c("span", { staticClass: "zoho-contact-id-text" }, [
                        _vm._v(
                          _vm._s(
                            (slotProps.row &&
                              slotProps.row.zohoInfo &&
                              slotProps.row.zohoInfo.contactId) ||
                              "-"
                          )
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: "cell-zohoLeadId",
                  fn: function (slotProps) {
                    return [
                      _c("span", { staticClass: "zoho-lead-id-text" }, [
                        _vm._v(
                          _vm._s(
                            (slotProps.row &&
                              slotProps.row.zohoInfo &&
                              slotProps.row.zohoInfo.leadId) ||
                              "-"
                          )
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: "cell-broadcastStatus",
                  fn: function (slotProps) {
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "broadcast-status",
                          class:
                            "broadcast-" +
                            _vm.getBroadcastStatus(slotProps.row),
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.getBroadcastStatusText(slotProps.row)
                              ) +
                              "\n                    "
                          ),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "cell-broadcastAnswered",
                  fn: function (slotProps) {
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "broadcast-answered",
                          class: {
                            "answered-active": _vm.getBroadcastAnswered(
                              slotProps.row
                            ),
                          },
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v(
                              _vm._s(
                                _vm.getBroadcastAnswered(slotProps.row)
                                  ? "reply"
                                  : "reply_all"
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.getBroadcastAnsweredText(slotProps.row)
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  },
                },
                _vm._l(_vm.contactProperties, function (property) {
                  return {
                    key: "cell-contactProperty_" + property._id,
                    fn: function (slotProps) {
                      return [
                        property.type === "json" &&
                        _vm.getContactPropertyRawValue(
                          slotProps.row,
                          property._id
                        )
                          ? _c(
                              "div",
                              {
                                staticClass: "json-badge",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.openJsonModal(
                                      slotProps.row,
                                      property._id
                                    )
                                  },
                                },
                              },
                              [
                                _c(
                                  "i",
                                  { staticClass: "material-icons json-icon" },
                                  [_vm._v("code")]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "json-text" }, [
                                  _vm._v("JSON"),
                                ]),
                              ]
                            )
                          : _c("span", [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.getContactPropertyValue(
                                      slotProps.row,
                                      property._id
                                    )
                                  ) +
                                  "\n                    "
                              ),
                            ]),
                      ]
                    },
                  }
                }),
                {
                  key: "empty",
                  fn: function () {
                    return [
                      _c("div", { staticClass: "empty-state" }, [
                        _c("i", { staticClass: "material-icons empty-icon" }, [
                          _vm._v("people_outline"),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "empty-text" }, [
                          _vm._v(
                            _vm._s(_vm.$t("chat.contactList.noContactsFound"))
                          ),
                        ]),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              true
            ),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.jsonModal.visible
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.jsonModal.title,
                showFooter: false,
                design: "v3",
              },
              on: { cancel: _vm.closeJsonModal },
            },
            [
              _c("prism-editor", {
                staticClass: "my-editor",
                attrs: {
                  value: _vm.jsonModal.content,
                  "line-numbers": false,
                  highlight: _vm.highlighter,
                  readonly: "",
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "space-between",
                    "margin-top": "16px",
                  },
                },
                [
                  _c("SupsisButton", { on: { click: _vm.copyJsonContent } }, [
                    _vm._v(_vm._s(_vm.$t("message.copy"))),
                  ]),
                  _vm._v(" "),
                  _c("SupsisButton", { on: { click: _vm.closeJsonModal } }, [
                    _vm._v(_vm._s(_vm.$t("message.cancel"))),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }